$(document).ready(function() {

  // Loop through all iframes inside of the video wrapper on the page
    $('.fluid-width-video-wrapper iframe', 'p iframe').each(function() {

    // Get the src attribute of the current iframe
    var src = $(this).attr('src');

    // Check if the src attribute exists
    if (src) {
      // Create a new string with the src attribute content
      var srcString = '<span class="iframe-video-url">Video url: ' + src + '</span>';

      // Insert the src string after the current iframe
      $(srcString).insertAfter(this);
    }
  });
});
